import { css } from "@vitality-ds/system";
export default css({
  flex: 1
});